import { type ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

import { PictureInPictureContext } from './picture-in-picture-context';

/** Renders children into the PiP window via a React portal. Returns null when PiP is closed. */
export function PictureInPicturePortal({ children }: { children: ReactNode }) {
  const { isPipOpen, pipWindow } = useContext(PictureInPictureContext);
  if (!isPipOpen || !pipWindow) return null;
  return createPortal(children, pipWindow.document.body);
}
